import { DataProvider, useSetFlowToBasedOnData } from 'Simple/Data'
import useFetch from 'Data/useFetch'
import useDataTransform from './useDataTransform.js'
import useDataConfiguration from './useDataConfiguration.js'
import React from 'react'
import View from './view.js'

/** @type {import('Simple/types.js').Data} */
export default function ReportData(props) {
  let configuration = useDataConfiguration(props)
  let [{ data: rdata, error }] = useFetch(configuration.variables.url, {
    // headers: { 'Content-Type': 'application/json' },
    cache: 'reload',
  })
  let data = useDataTransform(props, rdata)

  useSetFlowToBasedOnData({
    data,
    fetching: !data,
    error,
    pause: configuration.pause,
    viewPath: props.viewPath,
  })

  return (
    <DataProvider context="report_table" value={data} viewPath={props.viewPath}>
      <View {...props} />
    </DataProvider>
  )
}
